import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TrustSection from "./components/TrustSection";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import WhyUs from "./components/WhyUs";
import Process from "./components/Process";
import Founder from "./components/Founder";
import CTA from "./components/CTA";
import Footer from "./components/Footer";
import OurClientLayout from "./components/OurClientLayout";
import Benifits from "./components/Benifits";

export default function App() {
  return (
    <div className="bg-white text-black font-body overflow-x-hidden">
      <Navbar />
      <Hero />
      <TrustSection />
      <Benifits/>
      <Services />
      <Portfolio />
      <WhyUs />
      <Process />
      <OurClientLayout/>
    
      <Founder />
      <CTA />
      <Footer />

      {/* WhatsApp floating button */}
      <a
        href="https://wa.me/91XXXXXXXXXX"
        target="_blank"
        rel="noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-accentGreen rounded-full flex items-center justify-center shadow-2xl shadow-accentGreen/30 hover:scale-110 transition-transform duration-300"
        title="Chat on WhatsApp"
      >
        <svg className="w-7 h-7 text-dark" fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          <path d="M12 0C5.373 0 0 5.373 0 12c0 2.127.555 4.126 1.526 5.859L0 24l6.335-1.507A11.945 11.945 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.891 0-3.667-.5-5.207-1.375l-.375-.219-3.758.894.952-3.664-.244-.389A9.93 9.93 0 012 12c0-5.514 4.486-10 10-10s10 4.486 10 10-4.486 10-10 10z"/>
        </svg>
      </a>
    </div>
  );
}
